import React from 'react';
import { Container, Body5, SvgLoadingIcon, SVG_LOADING_ICON_TYPES } from '@ui';
import { useColorTheme } from '@hooks';

export const RefiningAnswer = () => {
  const colorTheme = useColorTheme();
  return (
    <Container verticallyCenter top={0} bottom={8} height={68}>
      <SvgLoadingIcon type={SVG_LOADING_ICON_TYPES.bars} color={colorTheme.text} />
      <Container left={12}>
        <Body5>Refining Response...</Body5>
      </Container>
    </Container>
  );
};
